<template>
  <div class="container no-margin">
    <text-input
      :label="getLabel"
      v-mask="'##-########-#'"
      :name="name"
      @input="onInput"
      :required="required"
      :hint="getLabel"
      pattern="[0-9]*"
      inputmode="numeric"
      @click="$emit('click')"
      :value="value"
      :subhint="subhint"
      :validationError="validationError"
      analyticsName="ingresá cuil"
      :analyticsTypology="config.analyticsTypology"
      :quantumObfuscate="quantumObfuscate"
    />
  </div>
</template>

<script>
import TextInput from "@/components/core/TextInput";
import { mask } from "vue-the-mask";
import { isValidCuil } from "@/utils";

export default {
  name: "CuilInput",
  components: { TextInput },
  directives: {
    mask
  },
  props: {
    value: String,
    label: String,
    hint: String,
    required: Boolean,
    subhint: String,
    name: String,
    type: String,
    quantumObfuscate: {
      type: Boolean,
      default: false
    }
  },
  data() {
    return {
      validationError: null,
      checked: false,
      typeCuil: {
        49: "CUIL",
        50: "CUIT"
      }
    };
  },
  computed: {
    getLabel() {
      return this.label ? this.label : `Ingresá ${this.typeCuil[this.type]}`;
    }
  },
  methods: {
    onInput(val) {
      this.$emit("input", val);
      if (this.checked) {
        this.isValid(val);
      }
    },

    checkValid() {
      this.checked = true;
      return this.isValid();
    },

    isValid(val) {
      // Por problema de sincronía con v-bind, paso el valor
      // por parámetro en onInput
      let value = val ? val : this.value;

      /* Sobreescribir método de validación */
      if (value && !isValidCuil(value.replace(/\D/g, ""))) {
        // Cuit no válido
        this.validationError = `El ${this.typeCuil[this.type]} no es válido`;
        return false;
      }

      // Cuit válido
      this.validationError = null;
      return true;
    }
  }
};
</script>
